#import "../fragments/product-fragment.graphql"

mutation UpdateProduct($input: ProductUpdateInput!) {
    productUpdate(input: $input) {
        product {
            ...ProductFragment
        }
    }
}
